import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { setLocalTask } from '../store/actions/calendarActions';
import { TASKS_CONTAINER } from '../constants/common';
import { views } from '../constants/views';
import { generateLocalTask } from '../utils/generateLocalTask';
import { modes } from '../constants/modes';

const current = moment();
const currendHour = current.hours();
const currentMinute = current.minutes();
const minute = currentMinute < 30 ? 30 : 0;
const hour =
  currentMinute < 30 ? currendHour : current.clone().add(1, 'hours').hour();

const getToDate = (fromDate) => fromDate.clone().add(1, 'hours');

const useCellClickHandlers = () => {
  const dispatch = useDispatch();

  const itemToCalendar = useSelector((state) => state.itemToCalendarStore.item);

  const { calendarSheet, view, localTask, mode } = useSelector(
    (state) => state.newCalendarStore
  );

  const handleDayCellClick = useCallback(
    (rowIndex) => {
      if (localTask) {
        dispatch(setLocalTask(null));
      } else {
        const fromDate = calendarSheet
          .clone()
          .set({ hour: rowIndex, minute: 0 });
        const toDate = getToDate(fromDate);
        const task = generateLocalTask(itemToCalendar, fromDate, toDate);

        dispatch(setLocalTask(task));
      }
    },
    [dispatch, localTask, calendarSheet, itemToCalendar]
  );

  const handleWeekCellClick = useCallback(
    (rowIndex, dataIndex) => {
      if (localTask) {
        dispatch(setLocalTask(null));
      } else {
        const fromDate = calendarSheet
          .clone()
          .startOf('week')
          .set({ day: dataIndex + 1, hour: rowIndex, minute: 0 });
        const toDate = getToDate(fromDate);
        const task = generateLocalTask(itemToCalendar, fromDate, toDate);

        dispatch(setLocalTask(task));
      }
    },
    [dispatch, localTask, calendarSheet, itemToCalendar]
  );

  const handleMonthCellClick = useCallback(
    (e, index) => {
      if (e.target.dataset.element !== TASKS_CONTAINER) {
        return;
      }

      if (localTask) {
        dispatch(setLocalTask(null));
      } else {
        const fromDate = calendarSheet
          .clone()
          .startOf(views.month)
          .startOf('week')
          .add(index, 'days')
          .set({ hour, minute });
        const toDate = getToDate(fromDate);
        const task = generateLocalTask(itemToCalendar, fromDate, toDate);

        dispatch(setLocalTask(task));
      }
    },
    [dispatch, localTask, calendarSheet, itemToCalendar]
  );

  const handleAgendaCellClick = useCallback(
    (e, index) => {
      if (e.target.dataset.element !== TASKS_CONTAINER) {
        return;
      }

      if (localTask) {
        dispatch(setLocalTask(null));
      } else {
        let fromDate;

        if (view === views.day) {
          fromDate = calendarSheet.clone().set({ hour, minute });
        }

        if (view === views.week) {
          fromDate = calendarSheet
            .clone()
            .startOf('week')
            .add(index, 'days')
            .set({ hour, minute });
        }

        if (view === views.month && mode === modes.calendar) {
          fromDate = calendarSheet
            .clone()
            .startOf(views.month)
            .startOf('week')
            .add(index, 'days')
            .set({ hour, minute });
        }

        if (view === views.month && mode === modes.agenda) {
          fromDate = calendarSheet
            .clone()
            .startOf(views.month)
            .add(index, 'days')
            .set({ hour, minute });
        }

        const toDate = getToDate(fromDate);
        const task = generateLocalTask(itemToCalendar, fromDate, toDate);

        dispatch(setLocalTask(task));
      }
    },
    [dispatch, localTask, calendarSheet, itemToCalendar, view, mode]
  );

  const handleAddTaskBtnClick = useCallback(() => {
    if (localTask) {
      dispatch(setLocalTask(null));
    } else {
      const fromDate = calendarSheet.clone().set({ hour, minute });
      const toDate = getToDate(fromDate);
      const task = generateLocalTask(itemToCalendar, fromDate, toDate);

      dispatch(setLocalTask(task));
    }
  }, [dispatch, localTask, calendarSheet, itemToCalendar]);

  return {
    handleDayCellClick,
    handleWeekCellClick,
    handleMonthCellClick,
    handleAgendaCellClick,
    handleAddTaskBtnClick,
  };
};

export default useCellClickHandlers;
